/* eslint-disable */

import React from "react";
import CashRegisterManager from "../features/cash-register-manager/view";

function Section() {
  return <CashRegisterManager />;
}

export default Section;
